import { makeAutoObservable } from "mobx";
import type { BaseStoreType } from "../common/types/BaseStoreType";
import type { FormValues } from "../common/types/formTypes";

type PersistedFormStoreType = BaseStoreType & {
   formStates: Map<string, FormValues>;
   setFormData(persistenceKey: string, formValues: FormValues): void;
   getFormData(persistenceKey: string): FormValues | undefined;
   clearFormData(persistenceKey: string): void;
};

const persistedFormStore: PersistedFormStoreType = makeAutoObservable({
   formStates: new Map(),

   setFormData: (persistenceKey, formValues) => {
      persistedFormStore.formStates.set(persistenceKey, formValues);
   },

   getFormData: (persistenceKey) => {
      return persistedFormStore.formStates.get(persistenceKey);
   },

   clearFormData: (persistenceKey) => {
      persistedFormStore.formStates.delete(persistenceKey);
   },

   clearCompanySpecificData: () => {
      persistedFormStore.formStates.clear();
   }
} satisfies PersistedFormStoreType);

export default persistedFormStore;
